import React from 'react';
// @ts-ignore
import styles from './ActionCenterNewMessage.module.scss';
import ActionCenterNewMessageForm, {
	ActionCenterNewMessageFormValues,
} from './ActionCenterNewMessageForm';
import {
	Conversation,
	ConversationMember,
	Message,
	MessageAttachment,
} from '../../Interfaces/Conversation.interface';
import { ConversationType } from '../../Enums/ConversationType.enum';
import { MultiSearchWithCheckListItemType } from '../../../Base/Enums/MultiSearchWithCheckListItemType.enum';
import apiClient from '../../../../Services/ApiClient';
import useApiClient from '../../../Base/Hooks/useApiClient';
import { MessageType } from '../../Enums/MessageType.enum';
import { MessageAttachmentType } from '../../Enums/MessageAttachmentType.enum';
import useNotification from '../../../../Hooks/useNotification.hook';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	onSuccess?: () => void;
	defaultData?: object;
}

const ActionCenterNewMessage: React.FC<Props> = ({
	defaultData,
	onSuccess,
}) => {
	const { displayError } = useApiClient();
	const { showNotificationSuccess } = useNotification();
	const { t } = useTranslation();
	const handleSuccess = async (values: ActionCenterNewMessageFormValues) => {
		const conversationMembers: ConversationMember[] = [];

		values?.recipients.forEach(item => {
			switch (item.type) {
				case MultiSearchWithCheckListItemType.DOCTOR:
				case MultiSearchWithCheckListItemType.PATIENT:
				case MultiSearchWithCheckListItemType.NON_DOCTOR:
					if (typeof item.value === 'string') {
						conversationMembers.push({
							userId: item.value,
						});
					}
					break;
				case MultiSearchWithCheckListItemType.GROUP:
					if (typeof item.value === 'string') {
						conversationMembers.push({
							groupId: item.value,
						});
					}
					break;
			}
		});

		const conversation: Conversation = {
			name: values.subject,
			type: ConversationType.NORMAL,
			conversationMembers,
		};

		try {
			const createdConversation = await apiClient.post(
				'/conversation/',
				conversation,
			);
			if (createdConversation.status === 200) {
				const attachments: MessageAttachment[] = [];

				if ((values?.questionnaireIds?.length || 0) > 0) {
					values?.questionnaireIds?.forEach(item => {
						if (typeof item.value === 'string') {
							attachments.push({
								questionnaireId: item.value,
								type: MessageAttachmentType.QUESTIONNAIRE,
							});
						}
					});
				}

				if ((values?.educationMaterialIds?.length || 0) > 0) {
					values?.educationMaterialIds?.forEach(item => {
						if (typeof item.value === 'string') {
							attachments.push({
								educationMaterialId: item.value,
								type: MessageAttachmentType.EDUCATION_MATERIAL,
							});
						}
					});
				}

				const message: Message = {
					conversationId: createdConversation.data.id,
					text: values.content,
					type: MessageType.TEXT,
					content: {
						text: values.content,
					},
					showOnHomeScreen: true,
					attachments,
				};

				const createdMessage = await apiClient.post(
					`/conversation/${createdConversation.data.id}/message`,
					message,
				);
				if (createdMessage.status === 200) {
					showNotificationSuccess({ content: t('base.messageSent') });
					onSuccess?.();
				}
			}
		} catch (e) {
			displayError(e);
		}
	};

	return (
		<div className={styles.wrapper}>
			<ActionCenterNewMessageForm
				onSuccess={handleSuccess}
				defaultData={defaultData}
			/>
		</div>
	);
};

export default ActionCenterNewMessage;
